<template>
  <v-form ref="form" v-bind="this.$attrs" class="mb-6">
    <v-row>
      <v-col cols="12" sm="6" md="12">
        <v-text-field
          v-model="licensePlate"
          label="Biển số xe"
          outlined
          required
          dense
          hide-details
          class="required font-size"
          :rules="[$rules.required]"
        />
      </v-col>
      <v-col cols="12" sm="6" md="12">
        <v-text-field
          v-model="carRegistration"
          label="Đăng kí xe"
          outlined
          required
          dense
          hide-details
          class="required font-size"
          :rules="[$rules.required]"
        />
      </v-col>
      <v-col cols="12" sm="6" md="12">
        <v-text-field
          v-model="inspection"
          label="Ngày đăng kiểm"
          outlined
          required
          dense
          hide-details
          class="required font-size"
          :rules="[$rules.required]"
        />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
export default {
  props: {
    oldData: {
      type: Object
    }
  },
  data() {
    return {
      licensePlate: '',
      carRegistration: '',
      inspection: ''
    }
  },
  methods: {
    getData() {
      if (this.$refs.form.validate()) {
        return {
          licensePlate: this.licensePlate,
          carRegistration: this.carRegistration,
          inspection: this.inspection
        }
      }
    },
    valueChange(attribute, data) {
      this[attribute] = data.value
    }
  },
  watch: {
    oldData: {
      handler(value) {
        if (value) {
          this.licensePlate = this.oldData.licensePlate
          this.carRegistration = this.oldData.carRegistration
          this.inspection = this.oldData.inspection
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style></style>
